import { WebApiService } from '../../../../plugins/webApiService'
import { SendRequestModel } from '../../../../plugins/models/SendRequestModel'
import HubInfo from '../../../../projects/autotest/i-service/test-hub/models/HubInfo';
import HubMessage from '../../../../projects/autotest/i-service/test-hub/models/HubMessage';

export default class TestHubPoolService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	
	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
	}

	async AcceptHub(hubInfo: HubInfo) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TestHubPoolService',
			Method: 'AcceptHub',
			Value: typeof(hubInfo) === 'object' ? JSON.stringify(hubInfo) : hubInfo,
		})

		webApiService.send(sendRequest);
	}

	async Receive(hubMessage: HubMessage) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TestHubPoolService',
			Method: 'Receive',
			Value: typeof(hubMessage) === 'object' ? JSON.stringify(hubMessage) : hubMessage,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
}